module.exports = __webpack_public_path__ + "static/media/hw_yu_37.74a9b298.flv";